import { Avatar, AvatarFallback, AvatarImage } from '~/components/ui/avatar'
import { Tooltip, TooltipContent, TooltipTrigger } from '~/components/ui/tooltip'

interface UserAvatarProps {
  firstName: string
  lastName: string
  avatar?: string
  withTooltip?: boolean
  size?: 'default' | 'sm' | 'lg' | 'xl'
}

export const UserAvatar = ({
  firstName,
  lastName,
  avatar,
  withTooltip,
  size = 'lg',
}: UserAvatarProps) => {
  const fallback = firstName.charAt(0) + lastName.charAt(0)
  const avatarEl = (
    <Avatar size={size}>
      <AvatarImage src={avatar} />
      <AvatarFallback>{fallback}</AvatarFallback>
    </Avatar>
  )

  if (!withTooltip) return avatarEl

  return (
    <Tooltip>
      <TooltipTrigger render={avatarEl} />
      <TooltipContent>
        {firstName} {lastName}
      </TooltipContent>
    </Tooltip>
  )
}
